import { render } from "./table.md?vue&type=template&id=171b44fa"
import script from "./table.md?vue&type=script&lang=js"
export * from "./table.md?vue&type=script&lang=js"
script.render = render

export default script